const AUTOFILL_INPUT_CLASS = 'dsg-autofill-input';
// Tailwind's `autofill:` variant compiles to `:autofill`, which some browser
// versions don't reliably match for the forced UA background paint. Plain
// CSS targeting `:-webkit-autofill` directly is the well-known, reliable fix.
const autofillOverrideStyle = `
  .${AUTOFILL_INPUT_CLASS}:-webkit-autofill,
  .${AUTOFILL_INPUT_CLASS}:-webkit-autofill:hover,
  .${AUTOFILL_INPUT_CLASS}:-webkit-autofill:focus,
  .${AUTOFILL_INPUT_CLASS}:-webkit-autofill:active {
    -webkit-text-fill-color: var(--color-text-body);
    -webkit-box-shadow: inset 0 0 0 1000px var(--color-input-background-default);
    box-shadow: inset 0 0 0 1000px var(--color-input-background-default);
    transition: background-color 600000s 0s, color 600000s 0s;
  }
`;

export { AUTOFILL_INPUT_CLASS, autofillOverrideStyle };
